import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
import microApp from "@micro-zoe/micro-app";
var namespaceSetting = {
  name: "".concat(process.env.APP_NAME, "_").concat(process.env.APP_VERSION, "_MicroAppStore")
};
var initialState = {
  forceClearHomeCache: false,
  microApps: [],
  excludeAssetFilter: void 0,
  monitorConfig: {},
  initMicroApps: function initMicroApps() {},
  setActivated: function setActivated() {},
  setStatus: function setStatus() {},
  setMonitorConfig: function setMonitorConfig() {}
};

// create the store
export var useMicroAppStore = createWithEqualityFn()(devtools(function (set, get) {
  return _objectSpread(_objectSpread({}, initialState), {}, {
    initMicroApps: function initMicroApps(apps, options) {
      var forceClearHomeCache = (options === null || options === void 0 ? void 0 : options.forceClearHomeCache) || get().forceClearHomeCache || false;
      var newApps = _toConsumableArray(apps || get().microApps);
      if (forceClearHomeCache) {
        newApps.forEach(function (el) {
          if (el.url) {
            el.url = "".concat(el.url, "?v=").concat(Math.random().toString(36).substring(2, 15));
          }
        });
      }
      set({
        forceClearHomeCache: forceClearHomeCache,
        microApps: newApps.map(function (el) {
          return _objectSpread(_objectSpread({}, el), {}, {
            status: "uninitialized",
            activated: false
          });
        })
      });
    },
    setActivated: function setActivated(appName) {
      set(function (state) {
        if (!appName) {
          return {
            microApps: state.microApps.map(function (el) {
              return _objectSpread(_objectSpread({}, el), {}, {
                activated: false
              });
            })
          };
        }
        return {
          microApps: state.microApps.map(function (el) {
            return el.name === appName ? _objectSpread(_objectSpread({}, el), {}, {
              activated: true
            }) : _objectSpread(_objectSpread({}, el), {}, {
              activated: false
            });
          })
        };
      });
    },
    setStatus: function setStatus(appName, status) {
      set(function (state) {
        return {
          microApps: state.microApps.map(function (el) {
            return el.name === appName ? _objectSpread(_objectSpread({}, el), {}, {
              status: status
            }) : _objectSpread({}, el);
          })
        };
      });
    },
    setMonitorConfig: function setMonitorConfig(config) {
      set({
        monitorConfig: _objectSpread(_objectSpread({}, get().monitorConfig), config)
      });
    }
  });
}, namespaceSetting), shallow);

/**
 * 主向子应用信息传递(向单个应用)
 * @param appName 应用名
 * @param data 数据
 * @param callback 回调
 */
export var sendMessage = function sendMessage(appName, data, options) {
  if (options !== null && options !== void 0 && options.sync) {
    setTimeout(function () {
      microApp === null || microApp === void 0 || microApp.setData(appName, data, options === null || options === void 0 ? void 0 : options.callback);
    }, 0);
  } else {
    microApp === null || microApp === void 0 || microApp.setData(appName, data, options === null || options === void 0 ? void 0 : options.callback);
  }
};

/**
 * 主向子应用信息传递（全局）
 * @param data 数据
 * @param callback 回调
 */
export var sendGlobalMessage = function sendGlobalMessage(data, options) {
  var functionName = options !== null && options !== void 0 && options.force ? "forceSetGlobalData" : "setGlobalData";
  if (options !== null && options !== void 0 && options.sync) {
    setTimeout(function () {
      microApp === null || microApp === void 0 || microApp[functionName](data, options === null || options === void 0 ? void 0 : options.callback);
    }, 0);
  } else {
    microApp === null || microApp === void 0 || microApp[functionName](data, options === null || options === void 0 ? void 0 : options.callback);
  }
};

/**
 * 设置全局主题配置
 */
export var setGlobalThemeConfig = function setGlobalThemeConfig(config) {
  sendGlobalMessage({
    "@@themeConfig": config
  }, {
    sync: true
  });
};

/**
 * 设置全局locales配置
 */
export var setGlobalLocalesMessage = function setGlobalLocalesMessage(config, callback) {
  callback === null || callback === void 0 || callback();
  localStorage.setItem("umi_locale", config.locale);
  sendGlobalMessage({
    "@@localesConfig": config
  }, {
    sync: true
  });
};

/**
 * 全局推送退出登录（主要是子=>主）
 */
export var sendLogoutMessage = function sendLogoutMessage() {
  window.microApp.forceSetGlobalData({
    "@@logout": true
  });
};